import { render, staticRenderFns } from "./ProjectOrders.vue?vue&type=template&id=3a111c4b&scoped=true"
import script from "./ProjectOrders.vue?vue&type=script&lang=js"
export * from "./ProjectOrders.vue?vue&type=script&lang=js"
import style0 from "./ProjectOrders.vue?vue&type=style&index=0&id=3a111c4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a111c4b",
  null
  
)

export default component.exports